"use client"

import { motion } from "framer-motion"
import { ServiceCard } from "@/components/service-card"

const services = [
  {
    category: "Excursions",
    title: "Let me show you Taormina's treasures",
    description:
      "I'll take you beyond the guidebook to discover the real Taormina. Whether it's the ancient Greek theater, a wine tasting at a family vineyard, or hiking trails only locals know about—I'll plan it all around what you love.",
    images: [
      "/images/excursions/2.webp",
      "/images/excursions/1.webp",
      "/images/excursions/3.webp",
      "/images/excursions/4.webp",
      "/images/excursions/5.webp",
      "/images/excursions/6.webp",
      "/images/excursions/7.webp",
      "/images/excursions/8.webp",
    ],
    accentColor: "bg-emerald-200 text-emerald-900",
  },
  {
    category: "Hotels",
    title: "I'll find the perfect place for you",
    description:
      "After 15 years in hospitality, I know every hotel in Taormina personally. Tell me your style—boutique charm, sea views, or historic elegance—and I'll match you with a place that feels just right.",
    images: [
      "/images/hotels/4.webp",
      "/images/hotels/1.webp",
      "/images/hotels/2.webp",
      "/images/hotels/3.webp",
      "/images/hotels/6.webp",
      "/images/hotels/5.webp",
    ],
    accentColor: "bg-rose-200 text-rose-900",
  },
  {
    category: "Boats",
    title: "Experience Taormina from the sea",
    description:
      "Let's explore the stunning coastline together. I'll arrange private boat tours to Isola Bella, hidden coves, or sunset cruises along the bay. Just you, the Mediterranean, and unforgettable views.",
    images: [
      
      "/images/boats/1.webp",
      "/images/boats/2.webp",
      "/images/boats/3.webp",
      "/images/boats/4.webp",
      "/images/boats/6.webp",
      "/images/boats/5.webp",
    ],
    accentColor: "bg-amber-200 text-amber-900",
  },
  {
    category: "Transfers",
    title: "Travel stress-free with me",
    description:
      "I'll handle all your transportation needs in Taormina. Airport pickup, day trips to Mount Etna, or just getting around town—you'll always have comfortable, reliable transport waiting for you.",
    images: [
      "/private-driver-sicily-countryside.jpg",
       "/images/transfers/1.webp",
      "/images/transfers/2.webp",
      "/images/transfers/3.webp",
      "/luxury-car-transfer-sicily-coastal-road.jpg",
      "/luxury-mercedes-transfer-sicily-airport.jpg",
      
    ],
    accentColor: "bg-slate-200 text-slate-900",
  },
  {
    category: "Restaurants",
    title: "Dine at my favorite spots",
    description:
      "I'll get you into the best restaurants in Taormina—the ones locals actually go to. Whether you want fresh seafood by the water or traditional Sicilian home cooking, I'll make sure you have the best table and the perfect meal.",
    images: [
      "/images/restaurants/1.webp",
      "/images/restaurants/6.webp",
      "/images/restaurants/2.webp",
      "/images/restaurants/3.webp",
      "/images/restaurants/4.webp",
      "/images/restaurants/5.webp",
      "/images/restaurants/7.webp",
    ],
    accentColor: "bg-indigo-200 text-indigo-900",
  },
  {
    category: "Wedding",
    title: "I'll make your Taormina wedding perfect",
    description:
      "Planning a destination wedding? I'll be with you every step of the way. From finding the dream venue overlooking the sea to coordinating every detail with local vendors I trust—your celebration will be exactly what you imagined.",
    images: [
      "/images/wedding/1.jpg",
      "/images/wedding/8.webp",
      "/images/wedding/2.webp",
      "/images/wedding/3.webp",
      "/images/wedding/4.webp",
      "/images/wedding/5.webp",
      "/images/wedding/6.webp",
      "/images/wedding/7.webp",
      
    ],
    accentColor: "bg-emerald-200 text-emerald-900",
  },
]

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
}

export function ServicesSection() {
  return (
    <section id="services" className="py-16 sm:py-20 md:py-24 lg:py-32 bg-card">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-14 lg:mb-16 hidden lg:block"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground mb-3 sm:mb-4">
            How I can help you
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto font-sans">
            From the moment you arrive until your last goodbye, I'll be here to make your Taormina experience truly
            special
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="space-y-12 sm:space-y-14 lg:space-y-16"
        >
          {services.map((service, index) => (
            <ServiceCard key={service.category} {...service} reverse={index % 2 !== 0} />
          ))}
        </motion.div>
      </div>
    </section>
  )
}
